<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ws06aN/tc-custom/9781504058438.jpg?1734296097103" alt="This image is the cover for the book Murder on the Links, The Hercule Poirot Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder on the Links, The Hercule Poirot Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Hercule Poirot’s second appearance is “a remarkably good detective story” as the Belgian sleuth must determine who left a corpse on a golf course (<i>The New York Times Book Review</i>).</b><br/>  <br/> After introducing Hercule Poirot in <i>The Mysterious Affair at Styles</i>, Christie brought him back three years later in 1923 for this “ingenious” murder mystery set in France (<i>The New York Times Book Review</i>).<br/>  <br/> Instead of a hole in one, Poirot finds one in a hole—a body in a shallow grave next to a golf course. The man who summoned him from London to Merlinville-sur-Mer is the man who now lies in the ground, and the great Belgian detective, along with his companion, Capt. Arthur Hastings, intends to find out who put him there.<br/>  <br/> Fatally stabbed in the back with a letter opener, millionaire Paul Renauld leaves behind a widow who claims two masked men tied her up and abducted her husband. Monsieur Giraud of the Sûreté believes he has the investigation well in hand and doesn’t need assistance from Poirot. But as the clues gets progressively more complex, it will be a link to a similar cold case that helps Poirot catch the backstabber.<br/>  <br/><i>This ebook has been professionally proofread to ensure accuracy and readability on all devices.</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Agatha Christie
      </h2>
      
      <p class="authorDescription body article">Agatha Christie (1890&ndash;1976) is listed in the Guinness Book of World Records as the bestselling novelist of all time. The first recipient of the Mystery Writers of America&rsquo;s Grand Master Award, she published eighty mystery novels and many short story collections and created such iconic fictional detectives as Hercule Poirot, Miss Jane Marple, and Tommy and Tuppence Beresford. She is known around the world as the Queen of Crime.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79e1eaee